(function(){
function init(root){
/* Select only one approved ranch-loop source for the current screen. */
root.querySelectorAll('.five-l-responsive-ranch-video').forEach(function(v){
 if(v.dataset.responsiveReady)return;v.dataset.responsiveReady='1';
 var mobile=matchMedia('(max-width:760px)').matches;
 var source=mobile?v.dataset.mobileSrc:v.dataset.desktopSrc;
 var poster=mobile?v.dataset.mobilePoster:v.dataset.desktopPoster;
 if(poster)v.poster=poster;
 v.muted=true;
 if(matchMedia('(prefers-reduced-motion:reduce)').matches)v.removeAttribute('autoplay');
 if(source){v.src=source;v.load();}
});

root.querySelectorAll('[data-five-l-photo-entrance]').forEach(function(banner){
 if(banner.dataset.photoReady)return;banner.dataset.photoReady='1';
 var photo=banner.querySelector('img');if(!photo)return;
 function reveal(){if(photo.naturalWidth>0)requestAnimationFrame(function(){banner.classList.add('five-l-photo-entered');});}
 if(photo.complete)reveal();else photo.addEventListener('load',reveal,{once:true});
});
root.querySelectorAll('.five-l .nav-dropdown').forEach(function(d){
 if(d.dataset.ready)return;d.dataset.ready='1';
 d.addEventListener('toggle',function(){if(d.open)d.closest('.nav').querySelectorAll('.nav-dropdown').forEach(function(other){if(other!==d)other.open=false;});});
});


root.querySelectorAll('.five-l .table-moment video').forEach(function(v){
 if(v.dataset.ready)return;v.dataset.ready='1';
 var section=v.closest('.table-moment'),button=section.querySelector('.dinner-video-toggle'),reduce=matchMedia('(prefers-reduced-motion:reduce)'),started=false,manualPause=false;
 v.muted=true;
 function fallback(){section.classList.add('video-fallback');v.pause();if(button)button.hidden=true;}
 function play(){if(reduce.matches||manualPause)return;section.classList.remove('video-fallback');v.play().then(function(){if(button){button.hidden=false;button.textContent=button.dataset.pauseLabel;button.setAttribute('aria-label',button.dataset.pauseLabel);}}).catch(fallback);}
 function load(){if(reduce.matches)return fallback();if(!started){started=true;v.querySelectorAll('source[data-src]').forEach(function(s){s.src=s.dataset.src;});v.load();}play();}
 v.addEventListener('error',fallback);
 if(button)button.addEventListener('click',function(){if(v.paused){manualPause=false;play();}else{manualPause=true;v.pause();button.textContent=button.dataset.playLabel;button.setAttribute('aria-label',button.dataset.playLabel);}});
 reduce.addEventListener('change',function(){if(reduce.matches)fallback();else if(section.getBoundingClientRect().bottom>0&&section.getBoundingClientRect().top<innerHeight)load();});
 if(reduce.matches)fallback();
 if('IntersectionObserver' in window)new IntersectionObserver(function(entries){entries.forEach(function(e){if(e.isIntersecting)load();else v.pause();});},{rootMargin:'100px 0px',threshold:0}).observe(section);else load();
});
root.querySelectorAll('.five-l .menu-toggle').forEach(function(t){if(t.dataset.ready)return;t.dataset.ready='1';t.addEventListener('click',function(){var open=t.getAttribute('aria-expanded')!=='true';t.setAttribute('aria-expanded',String(open));var nav=t.closest('.five-l').querySelector('.nav');if(nav)nav.classList.toggle('open',open);});});
root.querySelectorAll('.five-l [data-rail]').forEach(function(b){if(b.dataset.ready)return;b.dataset.ready='1';b.addEventListener('click',function(){var rail=b.closest('.five-l').querySelector('.product-rail');if(rail)rail.scrollBy({left:rail.clientWidth*.76*Number(b.dataset.rail),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});});});
root.querySelectorAll('.five-l .hero video').forEach(function(v){if(v.dataset.ready)return;v.dataset.ready='1';var hero=v.closest('.hero'),button=hero.querySelector('.video-toggle');v.muted=true;v.setAttribute('playsinline','');if(matchMedia('(prefers-reduced-motion:reduce)').matches){v.pause();hero.classList.add('video-fallback');}v.addEventListener('error',function(){hero.classList.add('video-fallback');});v.addEventListener('loadeddata',function(){if(!matchMedia('(prefers-reduced-motion:reduce)').matches)hero.classList.remove('video-fallback');});if(button)button.addEventListener('click',function(){if(v.paused){v.play().then(function(){button.textContent=button.dataset.pauseLabel;button.setAttribute('aria-label',button.dataset.pauseLabel);}).catch(function(){hero.classList.add('video-fallback');});}else{v.pause();button.textContent=button.dataset.playLabel;button.setAttribute('aria-label',button.dataset.playLabel);}});});
}
function refreshCount(){fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){document.querySelectorAll('.five-l-cart-count').forEach(function(b){b.textContent=c.item_count;b.hidden=c.item_count===0;});}).catch(function(){});}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){init(document);});else init(document);
document.addEventListener('shopify:section:load',function(e){init(e.target);});
document.addEventListener('cart:add',refreshCount);
if(window.jQuery)window.jQuery(document).ajaxComplete(function(e,x,o){if(o&&o.url&&/cart\/(add|change|update)/.test(o.url))refreshCount();});
document.addEventListener('keydown',function(e){if(e.key==='Escape'){document.querySelectorAll('.five-l .nav-dropdown').forEach(function(d){d.open=false;});document.querySelectorAll('.five-l .menu-toggle').forEach(function(t){t.setAttribute('aria-expanded','false');});document.querySelectorAll('.five-l .nav').forEach(function(n){n.classList.remove('open');});}});
document.addEventListener('click',function(e){document.querySelectorAll('.five-l .nav-dropdown[open]').forEach(function(d){if(!d.contains(e.target))d.open=false;});});
})();

/* Preserve a shopper's chosen Recharge delivery plan across variant changes.
   This only affects this draft's form selection, never subscription contracts. */
(function () {
  'use strict';
  var choices = new WeakMap();
  var pending = false;
  function reconcile() {
    pending = false;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      var select = form.querySelector('select[name="selling_plan"]');
      if (!select || !select.value) return;
      if (!choices.has(form)) {
        choices.set(form, select.value);
        return;
      }
      var wanted = choices.get(form);
      if (select.value === wanted) return;
      var available = Array.prototype.some.call(select.options, function (o) {
        return o.value === wanted && !o.disabled;
      });
      if (!available) return; // Never force a plan unavailable for this variant.
      var setter = Object.getOwnPropertyDescriptor(HTMLSelectElement.prototype, 'value').set;
      setter.call(select, wanted);
      select.dispatchEvent(new Event('change', {bubbles:true}));
    });
  }
  function schedule() {
    if (pending) return;
    pending = true;
    requestAnimationFrame(function () { requestAnimationFrame(reconcile); });
  }
  document.addEventListener('change', function (event) {
    var target = event.target;
    if (!(target instanceof Element)) return;
    var form = target.closest('form[action*="/cart/add"]');
    if (!form) return;
    if (target.matches('select[name="selling_plan"]')) {
      // Only a real shopper's selection replaces their saved delivery choice.
      if (event.isTrusted) choices.set(form, target.value);
    } else if (target.matches('[data-single-option-selector], select[name="id"]')) {
      schedule();
      setTimeout(schedule, 150);
      setTimeout(schedule, 500);
    }
  }, true);
  new MutationObserver(schedule).observe(document.documentElement, {
    childList:true, subtree:true
  });
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', schedule);
  } else {
    schedule();
  }
})();
